import { type VincoloCardinalitaDTO } from '@framework/api-client/api/inquiries/schemas/vincoloCardinalitaDTO.ts';

export class SubmissionCardinalityLogic {
  static hasError(
    constraints: VincoloCardinalitaDTO[] | null | undefined,
  ): boolean {
    return constraints?.some(v => v.livello === 'ERRORE') ?? false;
  }

  static hasWarning(
    constraints: VincoloCardinalitaDTO[] | null | undefined,
  ): boolean {
    return constraints?.some(v => v.livello === 'AVVISO') ?? false;
  }

  static hasViolation(
    constraints: VincoloCardinalitaDTO[] | null | undefined,
  ): boolean {
    return (
      SubmissionCardinalityLogic.hasError(constraints) ||
      SubmissionCardinalityLogic.hasWarning(constraints)
    );
  }

  /**
   * Ritorna il primo messaggio di errore. Se non ce ne sono ritorna il primo
   * messaggio di avviso. Se non ce ne sono ritorna undefined.
   */
  static getPriorityMessage(cardinalityViolations: VincoloCardinalitaDTO[]) {
    const errorsMessage = cardinalityViolations.filter(
      v => v.livello === 'ERRORE',
    );
    if (errorsMessage.length > 0) {
      return errorsMessage[0].descrizione;
    }
    return SubmissionCardinalityLogic.getFirstWarningMessage(
      cardinalityViolations,
    );
  }

  static getFirstWarningMessage(
    cardinalityViolations: VincoloCardinalitaDTO[] | null | undefined,
  ): string | undefined | null {
    const warningsMessage = cardinalityViolations?.filter(
      v => v.livello === 'AVVISO',
    );
    if (warningsMessage?.length) {
      return warningsMessage[0].descrizione;
    }
    return undefined;
  }
}
